module.exports = __webpack_public_path__ + "img/SMT_08_Mr_Ong_Yunn_Shing.c7ef7dd3.jpg";